import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-3 bg-white p-25" }
const _hoisted_2 = { style: {"margin":"0 0 -15px 0"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4" }, [
      _createElementVNode("h5", { class: "mb-0" }, "Asset Allocation"),
      _createElementVNode("span", null, "Last 30 Days")
    ], -1)),
    _cache[1] || (_cache[1] = _createElementVNode("div", null, [
      _createElementVNode("span", { class: "d-block" }, "Total Value"),
      _createElementVNode("h3", { class: "fs-20 mb-0 mt-6" }, "$17,485")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isClient)
        ? (_openBlock(), _createBlock(_component_apexchart, {
            key: 0,
            type: "pie",
            height: "235",
            options: _ctx.assetAllocation,
            series: _ctx.allocation
          }, null, 8, ["options", "series"]))
        : _createCommentVNode("", true)
    ])
  ]))
}